module.exports = __webpack_public_path__ + "assets/retina_Tangent1Detailed.472d7c0fd39d746e0df5a62c4f4ad454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Tangent1Detailed.png
// module id = 737
// module chunks = 0